var map = {
	"app/trilce/cambio-contrasenia/cambio-contrasenia.module": [
		"../../../../../src/app/trilce/cambio-contrasenia/cambio-contrasenia.module.ts",
		"common",
		"cambio-contrasenia.module"
	],
	"app/trilce/login/login.module": [
		"../../../../../src/app/trilce/login/login.module.ts",
		"common",
		"login.module"
	],
	"app/trilce/olvido-contrasenia/olvido-contrasenia.module": [
		"../../../../../src/app/trilce/olvido-contrasenia/olvido-contrasenia.module.ts",
		"common",
		"olvido-contrasenia.module"
	],
	"app/trilce/restablecer-contrasenia/restablecer-contrasenia.module": [
		"../../../../../src/app/trilce/restablecer-contrasenia/restablecer-contrasenia.module.ts",
		"common",
		"restablecer-contrasenia.module"
	],
	"app/trilce/trilce.module": [
		"../../../../../src/app/trilce/trilce.module.ts",
		"trilce.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main